import { render, staticRenderFns } from "./GeneralCostsCardView.vue?vue&type=template&id=6c526b4a&scoped=true&"
import script from "./GeneralCostsCardView.vue?vue&type=script&lang=js&"
export * from "./GeneralCostsCardView.vue?vue&type=script&lang=js&"
import style0 from "./GeneralCostsCardView.vue?vue&type=style&index=0&id=6c526b4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c526b4a",
  null
  
)

export default component.exports